/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { MasterZoneRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { Observable } from 'rxjs';
import { MasterZoneListItem } from './master-zone-list-item.model';

@Injectable()
export class MasterZoneListBusinessService implements InitViewService {
  constructor(public masterZoneRest: MasterZoneRestService, private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get('masterZones'),
    };
  }

  findAllAsDataSource(): SlicedDataSource<MasterZoneListItem> {
    return this.masterZoneRest.findAllAsDataSource();
  }

  deactivate(masterZone: MasterZoneListItem): Observable<MasterZoneListItem> {
    return this.masterZoneRest.deactivate(masterZone);
  }

  validate(id: ID): Observable<any> {
    return this.masterZoneRest.validate(id);
  }
}
